<template>
    <div class="d-flex align-items-center">
        <portal to="headerOverlay" v-if="megaMenuCollapsed">
            <div
                class="main-menu__overlay"
                @click="closeMegaMenu"
                @mouseenter="closeMegaMenuDelayed"
            ></div>
        </portal>

        <div class="main-menu hidden-md-down h-100">
            <div
                @mouseenter="closeMegaMenuDelayedCancel"
                class="d-flex align-items-center h-100"
            >
                <slot name="extraItem"></slot>
                <slot name="items">
                    <template v-for="menuItem in mainMenu">
                        <slot
                            name="menuItem"
                            v-bind="{
                                menuItem,
                                mainMenuItemId,
                                megaMenuCollapsed,
                                selectMainMenuItem,
                                handleDoubleClickEvent,
                                cancelSelectMainMenuItem
                            }"
                        >
                            <div
                                v-if="!isLoading"
                                class="main-menu__item px-2"
                                :class="{
                                    'main-menu__item--not-active':
                                        mainMenuItemId !==
                                            menuItem.id_menu_item &&
                                        megaMenuCollapsed,
                                    'main-menu__item--active':
                                        mainMenuItemId ===
                                            menuItem.id_menu_item &&
                                        megaMenuCollapsed
                                }"
                                @click="selectMainMenuItem($event, menuItem)"
                                @mouseover="
                                    selectMainMenuItem($event, menuItem)
                                "
                                @mouseleave="cancelSelectMainMenuItem()"
                            >
                                <div class="d-block">
                                    <div class="main-menu__image">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 607 473"
                                            v-if="menuItem.icon == 'dog'"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M476 2c-12 2-26 11-35 23-7 8-13 21-23 44-9 24-17 40-23 48-10 13-25 19-56 23-7 1-28 2-76 2-86 0-84-1-126 17-38 16-54 21-74 21-18 0-31-4-47-14-9-6-14-7-16-4-1 2 5 10 11 15 19 16 42 22 77 21l20-2h3l-1 3c-4 9-5 20-6 56l-2 41c-5 17-30 54-44 64-4 3-5 5-9 13l-13 39c-3 13-4 34-1 41 2 8 6 13 12 17 5 2 6 3 20 3 21 0 27-3 26-12-1-5-11-15-16-16-6-1-12-4-14-10-3-6-2-14 2-25 7-18 19-31 38-45a374 374 0 0 0 92-90c9-12 10-13 13-14 10-1 29 7 47 19 14 10 21 13 32 16 11 2 33 2 57-1 21-2 39-2 41 0 1 1-2 39-6 71s-4 42 1 58c6 23 19 36 34 36 5 0 14-2 20-6 5-2 5-2 5-5-2-9-11-17-25-24-6-3-7-4-8-7-2-8 2-25 12-49a393 393 0 0 0 28-84c3-7 6-10 18-19l14-12c7-7 10-17 13-34 2-13 4-19 10-27 6-9 7-12 6-31-1-23 2-36 10-44 4-4 7-5 20-6 32-3 48-9 58-20 3-2 5-6 6-9l6-17c0-4-2-9-6-10l-18-5c-20-4-24-6-27-9s-7-12-7-16c0-6-6-9-30-19-18-7-29-9-43-6zm-12 17c-15 16-22 28-22 38 0 7 3 15 4 10l2-3c4-2 8 2 20 15 17 19 23 22 32 17 8-4 13-13 13-23 0-7-2-13-10-30-6-13-8-19-8-23 0-2 1 0 2 3 0 3 4 11 8 19 10 18 12 24 12 33 0 15-13 29-26 28-7-1-13-6-27-22l-13-13c-1 0-1 3 1 8l1 6-6-5c-10-9-12-20-4-34a131 131 0 0 1 28-31l-7 7z"
                                            />
                                            <path
                                                fill="currentColor"
                                                d="M200 278c-19 26-44 54-60 67-5 5-6 6-8 12-7 24-5 47 4 57 3 3 3 4 11 4 9 0 23-4 24-7l-1-5c0-5-8-12-14-14-4-2-5-3-6-6-3-11 6-24 28-41a421 421 0 0 0 56-71c-1-2-14-6-20-7h-6l-8 11zm166 33c-2 25 0 59 3 69 2 3 2 3 2 1a2232 2232 0 0 0 8-82l-7-2h-6l-1 14zm47 87c-2 9-2 17 0 19l8 1c5 0 8-1 13-3 8-4 9-6 6-11-2-5-6-8-14-11-10-3-11-3-13 5z"
                                            />
                                        </svg>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 240 300"
                                            v-if="menuItem.icon == 'cat'"
                                        >
                                            <g
                                                fill="currentColor"
                                                stroke="none"
                                                transform="translate(0.000000,300.000000) scale(0.0240000,-0.0240000)"
                                            >
                                                <path
                                                    fill="currentColor"
                                                    d="M8740 13161 c-58 -12 -139 -62 -218 -136 -90 -84 -285 -300 -401
    -445 -275 -343 -293 -352 -725 -370 -186 -7 -266 -15 -411 -41 -195 -35 -343
    -42 -407 -20 -27 9 -44 24 -63 57 -14 24 -28 44 -31 44 -3 0 3 -16 15 -35 11
    -19 18 -35 14 -35 -13 0 -135 93 -248 190 -226 193 -445 357 -545 409 -121 62
    -191 72 -270 39 -45 -20 -73 -51 -102 -113 -21 -46 -23 -63 -22 -205 1 -137 7
    -190 53 -457 80 -474 114 -603 198 -746 53 -90 56 -103 83 -305 61 -467 92
    -592 211 -855 29 -64 49 -123 48 -141 0 -17 2 -84 6 -148 l8 -117 -77 -38
    c-42 -20 -76 -41 -76 -45 0 -5 31 8 70 27 38 19 74 35 80 35 5 0 10 -14 10
    -30 0 -28 -6 -33 -77 -66 -320 -148 -705 -259 -1203 -349 -295 -54 -470 -105
    -769 -225 -232 -92 -642 -316 -911 -497 -421 -283 -883 -799 -1202 -1344 -377
    -646 -500 -986 -782 -2170 -158 -666 -202 -941 -237 -1489 -31 -488 30 -1128
    139 -1477 l20 -62 -32 -10 c-17 -5 -67 -13 -111 -16 -100 -8 -296 -45 -442
    -84 -62 -17 -162 -36 -223 -42 l-110 -12 2 -665 3 -664 140 -44 c147 -46 235
    -65 655 -138 319 -56 345 -59 790 -95 201 -17 401 -37 445 -45 164 -31 438
    -67 596 -77 428 -27 525 -24 799 31 191 39 296 85 418 184 l84 67 46 -15 c91
    -30 197 -56 234 -56 49 0 78 12 122 51 36 31 39 32 104 26 98 -8 159 6 202 47
    26 25 48 36 84 41 40 5 58 15 101 56 64 61 92 120 99 216 6 83 -4 118 -57 207
    -75 124 -189 230 -307 284 l-55 26 135 13 c286 29 400 23 417 -24 3 -10 12
    -25 18 -33 7 -8 45 -100 85 -205 108 -284 146 -353 249 -455 110 -110 197
    -154 403 -204 174 -43 229 -45 300 -11 48 23 56 24 116 14 80 -14 133 -7 180
    23 20 14 53 30 72 37 91 31 189 128 206 204 3 18 10 34 14 37 4 3 3 39 -1 81
    -8 67 -24 116 -77 222 -5 10 67 0 141 -20 64 -18 199 -13 252 7 17 7 60 11 97
    11 51 -2 77 3 109 19 67 35 130 106 180 206 45 89 46 93 38 151 -22 158 -134
    292 -330 393 -74 38 -221 80 -282 80 -38 0 -53 5 -73 25 -25 25 -25 26 -23
    192 1 166 -14 304 -56 523 -24 130 -27 208 -15 510 18 497 43 771 86 967 27
    122 136 456 259 788 42 116 103 287 136 380 74 211 110 267 267 413 226 210
    432 490 587 797 115 228 164 348 281 702 83 248 110 346 134 475 37 202 68
    470 76 648 3 77 16 189 30 260 38 197 70 431 104 745 17 160 34 314 38 343 l7
    54 100 -89 c143 -125 205 -176 204 -166 0 4 -68 67 -151 138 l-150 130 7 85
    c3 46 9 88 12 93 10 17 224 -172 323 -287 73 -84 105 -104 38 -24 -68 83 -207
    218 -286 278 -40 30 -72 62 -72 70 1 29 20 152 26 161 5 9 140 -58 377 -186
    48 -26 90 -45 93 -43 4 5 -273 157 -398 220 -46 22 -65 37 -60 45 6 9 42 3
    147 -27 262 -73 285 -79 285 -72 0 4 -94 34 -210 66 -115 32 -210 63 -210 67
    0 14 18 11 104 -16 44 -14 81 -23 83 -21 4 3 -104 46 -117 46 -5 0 -20 4 -34
    9 l-25 10 26 65 26 66 90 0 c50 0 88 3 85 6 -3 3 -42 8 -86 12 l-79 7 24 80
    c35 118 73 344 79 475 4 65 -1 226 -10 371 -18 279 -19 264 38 413 51 132 56
    177 66 591 15 598 -3 778 -92 885 -41 50 -112 74 -178 61z m-2853 -10958 c-3
    -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m-977 -88 c7 -33 14 -65 17
    -71 3 -7 -24 -16 -73 -23 -42 -6 -87 -14 -100 -17 l-24 -6 29 68 c25 61 34 72
    77 96 27 15 52 24 55 20 3 -4 12 -34 19 -67z m1015 -166 c18 -102 18 -116 6
    -104 -10 10 -42 264 -40 312 1 15 6 -6 11 -47 4 -41 15 -114 23 -161z m205
    -623 c0 -2 -21 1 -47 5 -27 4 -52 8 -58 9 -33 2 -36 18 -11 54 13 20 28 51 32
    69 7 31 8 30 46 -52 21 -46 38 -84 38 -85z"
                                                />
                                            </g>
                                        </svg>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 300 300"
                                            v-if="menuItem.icon == 'rabbit'"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M175.1 8l-1.3 10.8-1.3 8.1-5.4-5.4c-6.7-5.4-9.4-8.1-17.5-9.4-5.4-1.3-5.4-1.3-5.4 1.3l2.7 10.8 6.7 17.5 8.1 16.2 12.1 14.8c12.1 10.8 14.8 16.2 13.5 21.6-2.7 4-6.7 8.1-9.4 6.7h-1.3c1.3 1.3 0 2.7-1.3 4-2.7 2.7-13.5 4-21.6 1.3l-18.9-2.7c-14.8-1.3-14.8-1.3-47.2 6.7-22.9 5.4-22.9 5.4-45.8 40.4A158.7 158.7 0 0 0 24.3 179a65.2 65.2 0 0 0-6.7 37.7l2.7 13.5 1.3 4 1.3 4 2.7 5.4 1.3 5.4-8.1-1.3h-8.1v8.1c0 8.1 0 9.4 4 12.1l2.7 5.4 8.1 5.4c8.1 4 9.4 4 17.5 2.7l12.1 1.3c2.7 2.7 32.3 5.4 49.8 4 9.4 0 9.4 0 9.4 4v4h20.2l25.6-1.3 22.9-2.7 18.9-1.3 4-1.3 4-2.7v-2.7c2.7 0 9.4-4 9.4-6.7s-8.1-9.4-16.2-13.5c-6.7-2.7-9.4-2.7-16.2-2.7l-16.2 4-8.1 2.7 4-6.7c8.1-10.8 13.5-20.2 13.5-25.6 0-6.7 2.7-5.4 9.4 4 6.7 10.8 9.4 13.5 12.1 13.5 1.3 0 6.7 4 10.8 9.4l10.8 9.4 1.3 1.3 2.7 4c2.7 4 28.3 1.3 29.6-1.3 2.7-4-4-14.8-8.1-16.2-4-1.3-9.4-6.7-10.8-12.1L233 233c-4-8.1-4-9.4-2.7-12.1a58 58 0 0 1 13.5-20.2l5.4-8.1 2.7-5.4a96.9 96.9 0 0 0 10.8-24.2c0-4 5.4-9.4 10.8-12.1l5.4-5.4 2.7-5.4a26.6 26.6 0 0 0 8.1-18.9c0-5.4 0-6.7-4-8.1L279 105a144.8 144.8 0 0 0-21.6-25.6c-2.7-2.7-16.2-6.7-21.6-8.1-8.1-1.3-10.8-5.4-13.5-20.2-4-13.5-8.1-22.9-17.5-31-6.8-8-19-14.8-24.3-16.1-5.4 0-5.4 0-5.4 4z"
                                            />
                                        </svg>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 639 638"
                                            v-if="menuItem.icon == 'bird'"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M521 2a86 86 0 0 0-29 13l-4 3-6 7-8 10a407 407 0 0 0-25 31l-8 11-3 5-4 4-2 3-3 6-3 3-4 4c-5 7-9 11-12 13l-6 6-5 4-5 3-4 4a576 576 0 0 1-34 29 129 129 0 0 0-27 31l-12 16c-5 6-9 14-9 17l-10 13a109 109 0 0 0-25 37l-4 6c-1 3-4 8-7 10a214 214 0 0 0-23 23l-16 15a76 76 0 0 0-15 17c-2 6-2 7-5 9a591 591 0 0 0-58 49c-1 2-2 3-4 3l-4 5c1 1 4 0 7-2a92 92 0 0 1 18-8l10-5c3 0 3 1 3 4-1 3-12 15-16 17l-14 11-6 5c-2 0-6 4-10 10l-7 9c-2 3-3 4-2 6s2 2 5 0l3-1v2l-2 4c0 2-7 11-17 21l-10 11-1 1-2 1a567 567 0 0 1-52 53l-8 8-11 12-12 12-10 12c-3 3-3 4-3 12s0 8 2 7l1-3 1-1c1 0 7-5 13-12l13-12c3 1 2 5 0 8l-3 4-3 5-3 4-3 5-4 4-2 4-3 3-2 4c-3 4-4 8-3 8 2 2 9-4 27-21l15-14a1908 1908 0 0 0 112-113l7-6 12-11 14-11 6-3c3-2 7-4 10-4a254 254 0 0 0 22-5l7-1 10 2 5-1 4-1c3 0 3 0 3 3 0 2 0 3 3 4s6 2 7 1l8 2a354 354 0 0 0 119-9c1-2 8-1 16 4l5 2 4 4 5 3 5 1c2 2 1 9 0 11l-17 2c-19 0-24 2-30 8-4 5-5 7-3 8l2-1 4-1 4-2 49-1a671 671 0 0 1 50 2l5 7 4 6 1 2 1 1 1 7v8h-3l-5 1c-1 2-6 2-15 2-15 1-20 3-24 8s-3 6 1 4a1069 1069 0 0 1 119-3c3-1 18-1 28 1h6c1-1 1-1-1-3-1-2-4-3-7-4l-6-3c-4-2-12-3-28-4s-22-2-28-6l-3-1-15-7c-6-4-10-8-10-9l-2-3-1-3c0-3 0-3 11-3h13c4 1 9 0 9-2 0-1-3-4-5-4l-1-1c0-2-10-4-27-6l-9-1-5-5-6-9-2-5-3-9c-5-33-5-38 3-45l5-5 4-4c4-1 17-13 18-16l4-4 10-8 12-9c4-2 7-5 13-11l9-12 7-8c6-5 12-13 14-20l4-9c10-19 12-24 14-45l2-10 1-24-1-25c-6-20-7-27-7-48-1-17 0-21 3-27l1-6c0-2 1-3 5-5l16-7c5-3 11-5 13-5l6-2c0-2-16-17-20-19-3-1-5-3-6-5 0-2-2-3-2-3-1 0-3-4-6-13-6-16-15-27-32-38l-6-2-6-2-9-3c-10-2-26-2-30-1zm-74 434c4 6 13 16 15 16s10 8 10 10c0 3-10 2-16-1l-7-3-4-2-16-9c-6-2-7-10-1-13 3-2 11-4 15-4l4 6z"
                                            />
                                        </svg>
                                    </div>

                                    <a
                                        @click.prevent
                                        @dblclick.prevent="
                                            handleDoubleClickEvent($event)
                                        "
                                        :href="menuItem.interaction_link"
                                        :title="menuItem.interaction_title"
                                        v-text="menuItem.interaction_title"
                                        class="mr-2"
                                        rel="noopener noreferrer"
                                    ></a>
                                    <i
                                        class="fas fa-caret-down main-menu__item--triangle"
                                        :class="{
                                            'fas fa-caret-up main-menu__item--triangle':
                                                mainMenuItemId ===
                                                    menuItem.id_menu_item &&
                                                megaMenuCollapsed
                                        }"
                                    ></i>
                                </div>
                            </div>
                        </slot>
                    </template>
                    <div class="d-block">
                        <a
                            :href="brekzOfferPageLink"
                            :title="brekzOfferPageLinkText"
                            v-text="brekzOfferPageLinkText"
                            :class="
                                isMenuAlternativeMode
                                    ? 'main-menu__item main-menu__item--main-header'
                                    : 'main-menu__item--offer'
                            "
                            rel="noopener noreferrer"
                        ></a>
                    </div>
                </slot>

                <slot name="default" v-if="isLoading"> </slot>
            </div>

            <div
                @mouseenter="closeMegaMenuDelayedCancel"
                class="main-menu__mega-menu-wrapper"
                v-if="megaMenuCollapsed"
            >
                <div class="mega-menu">
                    <div class="row no-gutters">
                        <div class="col-lg-2">
                            <ul class="mega-menu__list">
                                <template v-for="menuItem in megaMenu">
                                    <li
                                        :key="menuItem.id_menu_item"
                                        class="mega-menu__list-item mega-menu__list-item--link"
                                        :class="{
                                            'mega-menu__list-item--active':
                                                megaMenuItemId ===
                                                menuItem.id_menu_item
                                        }"
                                        v-if="menuItem.interaction_link"
                                    >
                                        <a
                                            v-text="menuItem.interaction_title"
                                            :href="menuItem.interaction_link"
                                            :title="menuItem.interaction_title"
                                            rel="noopener noreferrer"
                                        ></a>
                                    </li>

                                    <li
                                        :key="menuItem.id_menu_item"
                                        class="mega-menu__list-item"
                                        :class="{
                                            'mega-menu__list-item--active':
                                                megaMenuItemId ===
                                                menuItem.id_menu_item
                                        }"
                                        @click="clickMegaMenuItem(menuItem)"
                                        @mouseover="
                                            selectMegaMenuItem(menuItem)
                                        "
                                        @mouseleave="cancelMegaMainMenuItem()"
                                        v-else
                                    >
                                        <span
                                            v-text="menuItem.interaction_title"
                                        ></span>
                                    </li>
                                </template>
                            </ul>

                            <div
                                class="mega-menu__list--img"
                                v-if="subMenuActive"
                            >
                                <img
                                    v-if="subMenuActive.image_left"
                                    :src="
                                        getImagePath(subMenuActive.image_left)
                                    "
                                    :alt="subMenuActive.interaction_title"
                                />
                            </div>
                        </div>
                        <div class="col-lg-10 sub-menu">
                            <div class="row h-100">
                                <div
                                    class="col-3 sub-menu__list"
                                    v-for="subMenuColumn in subMenuColumns"
                                >
                                    <template v-for="menuItem in subMenuColumn">
                                        <a
                                            v-if="menuItem.interaction_link"
                                            class="sub-menu__list-item"
                                            :class="{
                                                'sub-menu__list-item--border-bottom':
                                                    menuItem.has_border_bottom,
                                                'sub-menu__list-item--bold':
                                                    menuItem.is_bold,
                                                'sub-menu__list-item--title':
                                                    menuItem.is_title
                                            }"
                                            :href="menuItem.interaction_link"
                                            :title="menuItem.interaction_title"
                                            :key="menuItem.id_menu_item"
                                            rel="noopener noreferrer"
                                            >{{ menuItem.interaction_title }}</a
                                        >
                                        <span
                                            v-else
                                            :class="{
                                                'sub-menu__list-item--border-bottom':
                                                    menuItem.has_border_bottom,
                                                'sub-menu__list-item--bold':
                                                    menuItem.is_bold,
                                                'sub-menu__list-item--title':
                                                    menuItem.is_title
                                            }"
                                            :key="menuItem.id_menu_item"
                                            class="sub-menu__list-item"
                                            >{{
                                                menuItem.interaction_title
                                            }}</span
                                        >
                                    </template>
                                </div>

                                <div
                                    class=" d-flex align-items-center "
                                    v-bind:class="{
                                        'col-9 sub-menu__img-small justify-content-end': singleSubMenuColumn,
                                        'col-6 sub-menu__img': !singleSubMenuColumn
                                    }"
                                    v-if="subMenuActive"
                                >
                                    <img
                                        v-if="subMenuActive.image_right"
                                        :src="
                                            getImagePath(
                                                subMenuActive.image_right
                                            )
                                        "
                                        :alt="subMenuActive.page_title"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mega-menu__underbar bg-green w-100"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        lastModifiedTimestamp: String,
        brekzOfferPageLink: String,
        brekzOfferPageLinkText: String,
        isMenuAlternativeMode: Boolean
    },
    data() {
        return {
            megaMenu: undefined,
            subMenu: undefined,
            subMenuActive: undefined,
            subMenuColumns: [],
            singleSubMenuColumn: false,

            isLoading: true,
            megaMenuCollapsed: false,

            mainMenuItemId: undefined,
            megaMenuItemId: undefined,

            parentView: null,
            currentView: null,
            shouldBeFourColumns: true,
            shouldBeTwoColumn: false,
            shouldBeOneColumn: false,

            selectMainMenuItemEventId: null,
            selectMegaMenuItemEventId: null,

            delay: 100,
            closingDelay: 300,
            openingDelay: 300,
            megaMenuClosure: undefined
        };
    },
    created() {
        this.getMenu();

        window.EventBus.$on("close-menu", () => {
            this.closeMegaMenu();
        });

        window.EventBus.$on("select-item", value => {
            const mainMenuItem = this.mainMenu.find(item => {
                return item.interaction_value === value;
            });

            if (mainMenuItem) {
                this.selectMainMenuItem({}, mainMenuItem);
            }
        });
    },
    mounted() {},
    computed: {
        menu() {
            return this.$store.state.menu.items;
        },
        mainMenu() {
            if (!this.menu.items) {
                return;
            }

            return this.menu.items.filter(
                ({ id_menu_item_parent }) => id_menu_item_parent === 0
            );
        }
    },
    methods: {
        handleDoubleClickEvent(event) {
            this.goToLink(event.target.href);
        },
        goToLink(url) {
            window.location.href = url;
        },
        getMenu() {
            if (this.menu.items) {
                this.isLoading = false;
                return;
            }

            this.$store.dispatch("menu/setMenu").then(() => {
                localStorage.setItem(
                    "desktop_menu_structure",
                    JSON.stringify(this.menu)
                );
                localStorage.setItem(
                    "desktop_menu_structure_updated_at",
                    new Date().toJSON()
                );

                this.isLoading = false;

                if (this.mainMenu.length === 2) {
                    // Todo: Wat mee doen? "Uncaught (in promise) TypeError: Cannot read property 'length' of undefined"
                    this.shouldBeFourColumns = false;
                    this.shouldBeTwoColumn = true;
                }

                this.$nextTick(() => {
                    if (window.applyAbTestingToElement) {
                        window.applyAbTestingToElement(this.$el);
                    }
                });
            });
        },
        selectMainMenuItem(event, mainMenuItem) {
            let mainMenuDelay = event.type === "click" ? 0 : this.openingDelay;

            if (this.megaMenuCollapsed) {
                mainMenuDelay = this.delay;
            }

            if (this.selectMainMenuItemEventId) {
                this.cancelSelectMainMenuItem();
            }

            // FEATURE: Click on open item goes to link
            // if (event.type === 'click' && mainMenuItem.id_menu_item === this.mainMenuItemId) {
            //     let element = event.target;
            //
            //     if (element.tagName !== 'A') {
            //         while(! [...element.classList].includes('main-menu__item')) {
            //             element = element.parentElement;
            //         }
            //         element = element.querySelector('a');
            //     }
            //
            //     this.goToLink(event.target.href);
            // }

            this.selectMainMenuItemEventId = setTimeout(() => {
                this.mainMenuItemId = mainMenuItem.id_menu_item;
                this.megaMenu = this.menu.items.filter(
                    ({ id_menu_item_parent }) =>
                        id_menu_item_parent === mainMenuItem.id_menu_item
                );
                this.megaMenuCollapsed = true;
                let firstMegaMenuItem = this.megaMenu[0];

                if (firstMegaMenuItem !== undefined) {
                    this.clickMegaMenuItem(firstMegaMenuItem);
                }
            }, mainMenuDelay);
        },
        cancelSelectMainMenuItem() {
            clearTimeout(this.selectMainMenuItemEventId);
        },
        clickMegaMenuItem(megaMenuitem) {
            let parent_id = megaMenuitem.id_menu_item;

            this.megaMenuItemId = parent_id;
            this.subMenu = this.menu.items.filter(
                ({ id_menu_item_parent }) => id_menu_item_parent === parent_id
            );
            this.subMenuColumns = [];
            this.subMenuActive = megaMenuitem;

            let subMenuColumn = [];
            this.subMenu.forEach(subMenuItem => {
                if (subMenuItem.new_column) {
                    this.subMenuColumns.push(subMenuColumn);
                    subMenuColumn = [];
                }

                subMenuColumn.push(subMenuItem);
            });
            if (subMenuColumn.length) {
                this.subMenuColumns.push(subMenuColumn);
            }
            if (this.subMenuColumns.length === 1) {
                this.singleSubMenuColumn = true;
            } else {
                this.singleSubMenuColumn = false;
            }

            if (window.applyAbTestingToElement) {
                this.$nextTick(() => {
                  window.applyAbTestingToElement(this.$el);
                });
            }
        },
        selectMegaMenuItem(megaMenuItem) {
            this.selectMegaMenuItemEventId = setTimeout(() => {
                this.clickMegaMenuItem(megaMenuItem);
            }, this.delay);
        },
        cancelMegaMainMenuItem() {
            clearTimeout(this.selectMegaMenuItemEventId);
        },
        getImagePath(image_file_name) {
            return "/img/main-menu/" + image_file_name;
        },
        closeMegaMenu() {
            // TODO: Emit event or portal
            this.megaMenu = undefined;
            this.subMenu = undefined;
            this.subMenuActive = undefined;
            this.subMenuColumns = [];
            this.megaMenuCollapsed = false;
        },
        closeMegaMenuDelayed() {
            this.megaMenuClosure = setTimeout(() => {
                this.closeMegaMenu();
            }, this.closingDelay);
        },
        closeMegaMenuDelayedCancel() {
            if (this.megaMenuClosure === undefined) {
                return;
            }

            clearTimeout(this.megaMenuClosure);
        }
    }
};
</script>

<style></style>
